import React from "react";
import { computeDisplayOrder } from "../../utils/workflowGraph";

export default function WorkflowPreviewCard({ workflow, onStart }) {
  const allStages = workflow.stages || [];
  const { order, cycleStageIds } = computeDisplayOrder(workflow);
  const orderedStages = order.length ? order : allStages;

  // compute start stages (no incoming connections)
  // if none are found (fully cyclic graph), allow starting from any stage
  const startStages = allStages.filter(
    (s) => !(workflow.connections || []).some((c) => c.targetStageId === s.id),
  );
  const startOptions = startStages.length ? startStages : allStages;

  return (
    <div className="workflow-preview-card">
      <h2>{workflow.name}</h2>
      <p>{allStages.length} stages</p>

      <div className="stage-chain">
        {orderedStages.map((s, idx) => (
          <React.Fragment key={s.id}>
            <span className="stage-name">
              {s.name}{" "}
              {cycleStageIds.has(s.id) && (
                <span className="cycle-badge">(cycle)</span>
              )}
            </span>
            {idx < orderedStages.length - 1 && <span className="arrow">-&gt;</span>}
          </React.Fragment>
        ))}
      </div>

      {!startStages.length && allStages.length > 0 && (
        <p className="start-stage-hint">
          No root start stage found. This workflow appears cyclic, so you can
          start from any stage.
        </p>
      )}

      <div className="start-buttons">
        {startOptions.map((s) => (
          <button
            key={s.id}
            className="btn-primary"
            onClick={() => onStart(s.id)}
          >
            Start at {s.name}
          </button>
        ))}
      </div>
    </div>
  );
}
